import type { ComponentProps, PropsWithChildren } from 'react';
import { Heading } from '../Typography/Heading';

type BlogArticleTitle = PropsWithChildren<ComponentProps<typeof Heading>>;

export const BlogArticleTitle = ( { children, level = 'p' }: BlogArticleTitle ) => {

  return (
    <Heading
      level={ level }
      className={ 'font-onest text-base font-semibold text-[#ABB0C7] line-clamp-2' }>
      { children }
    </Heading>
  )
}
BlogArticleTitle.displayName = 'BlogArticleTitle';

